module.exports = require("./fr-FR.js");